import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import copyContainer from '../../../../actions/copyContainer';
import DuplicateContainer from './DuplicateContainer';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ copyContainer }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateContainer);
